import { render, staticRenderFns } from "./DeliveryShopSetting.vue?vue&type=template&id=4a91a4b8&scoped=true"
import script from "./DeliveryShopSetting.vue?vue&type=script&lang=js"
export * from "./DeliveryShopSetting.vue?vue&type=script&lang=js"
import style0 from "./DeliveryShopSetting.vue?vue&type=style&index=0&id=4a91a4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a91a4b8",
  null
  
)

export default component.exports